import { regSub, subscribe, subscription } from 'nike-re-framejs';
import { List, Map } from 'immutable';

regSub('ticketus/overview', db => db.getIn(['ticketus', 'overview'], Map()));

regSub(
    'ticketus/overview/list',
    () => subscribe(['ticketus/overview']),
    overview => overview.getIn(['list'])
);

regSub(
    'ticketus/overview/filter',
    () => subscribe(['ticketus/overview']),
    overview => overview.get('filter')
);

export const ticketusQuickTickets$ = subscription(db => db.getIn(['ticketus', 'quicktickets', 'list', 'data'], List()));

regSub('ticketus/quicktickets/status', db => db.getIn(['ticketus', 'quicktickets', 'status']));

regSub('ticketus/cashin/list/running', db =>
    db.getIn(['ticketus', 'cashin', 'tickets'], Map()).filter(data => data.get('status') === 'Running')
);

regSub('ticketus/overview/filter/status', db => db.getIn(['ticketus', 'overview', 'filter', 'status']));
